import { Filter } from './Filter';
import { getLocationsHierarchy, getZones as getAllZones, getMedia as getAllMedia, getCampaigns as getAllCampaigns, getPlaylists as getAllPlaylists, getAccount as getAccountData } from '../assets/libs/broox/brooxCloudApi';
import { AccountParams } from './AccountParams';

interface Collapsed {
  id: string,
  name: string
}

const getCategories = async (filter: Filter, params: AccountParams): Promise<string[]> => {
  const locations = await getLocations(filter, params);
  const categories: string[] = [];
  for(let location of locations) {
    for(let installation of location.installations) {
      for(let campaign of (installation as any).campaigns) {
        for(let category of campaign.categories) {
          if(!categories.includes(category)) {
            categories.push(category);
          }
        }
      }
    }
  }
  return categories;
}

const getLocations = async (filter: Filter, params: AccountParams): Promise<any[]> => {
  return await getLocationsHierarchy(filter, params.host, params.token || params.id, params.apiKey);
}

const getZones = async (filter: Filter, params: AccountParams): Promise<Collapsed[]> => {
  const zones = await getAllZones(filter, params.host, params.token || params.id, params.apiKey);
  return zones.map(zone => { return { id: zone, name: zone }});
}

const getCampaigns = async (filter: Filter, params: AccountParams): Promise<Collapsed[]> => {
  const campaigns = await getAllCampaigns(filter, params.host, params.token || params.id, params.apiKey);
  return campaigns.map(c => { return { id: c.id, name: c.name }});
}

const getPlaylists = async (filter: Filter, params: AccountParams): Promise<Collapsed[]> => {
  const playlists = await getAllPlaylists(filter, params.host, params.token || params.id, params.apiKey);
  return playlists.map(p => { return { id: p.id, name: p.name }});
}

const getMedia = async (filter: Filter, params: AccountParams): Promise<Collapsed[]> => {
  const media = await getAllMedia(filter, params.host, params.token || params.id, params.apiKey);
  return media.map(m => { return { id: m.id, name: m.name }});
}

const getAccount = async (params: AccountParams): Promise<Collapsed> => {
  const account = await getAccountData(params.host, params.token || params.id, params.apiKey);
  return { id: account.id, name: account.name };
}

const findById = (items: Collapsed[], id: string): Collapsed | null => {
  for(let i of items) {
    if(i.id === id) {
      return i;
    }
  }
  return null;
}

export { Collapsed, getLocations, getCategories, getZones, getCampaigns, getPlaylists, getMedia, getAccount, findById };